import React, { useState } from 'react'
import { Input, Button } from 'reactstrap'
import Page from './Page'
import { configContext } from '../App'
import { post } from '../modules/fetch'
import Icon from './Icon'
import { appContext } from '../App'

const Login = (props) => {
    const [email, setEmail] = useState('')
    const setEmailState = (e) => setEmail(e.target.value)
    const [password, setPassword] = useState('')
    const setPasswordState = (e) => setPassword(e.target.value)
    const [status, setStatus] = useState('ready')

    const login = (e, config) => {
        e && e.preventDefault()
        setStatus('loading')
        // console.log(e)
        const payload = { email, password }
        // console.log(config.endpoint_url+'login', payload)
        post('login', payload)
            .then((r) => console.log(r) || r)
            .then((r) => {
                if (r.data) {
                    localStorage.setItem('api_token', r.data.api_token)
                    setStatus('ready')
                    props.app.setState({ logged_in: true })
                } else {
                    setStatus('error')
                }
            })
        return false
    }

    return (
        <configContext.Consumer>
            {(config) => (
                <Page>
                    <form onSubmit={(e) => login(e, config)} className=" form offset-md-4 col-md-4 pt-5 mt-5">
                        <div className="form-group mb-2">
                            <label for="email">Email</label>
                            <Input type="text" className={(status === 'error' && ' is-invalid') || ''} id="email" value={email} onChange={setEmailState} />
                        </div>
                        <div className="form-group mb-2">
                            <label for="password">Password</label>
                            <Input
                                type="password"
                                className={(status === 'error' && ' is-invalid') || ''}
                                id="password"
                                value={password}
                                onChange={setPasswordState}
                            />
                        </div>
                        <div className="form-group mb-2 mt-4">
                            <Button className="w-100">
                                {(status === 'loading' && <Icon name="loading" key="loading" className="mr-2" />) || (
                                    <Icon name="lock" key="ready" className="mr-2" />
                                )}
                                Login
                            </Button>
                        </div>
                    </form>
                </Page>
            )}
        </configContext.Consumer>
    )
}

const LoginContainer = (props) => <appContext.Consumer>{(app) => <Login {...props} app={app} />}</appContext.Consumer>

export default LoginContainer
